module.exports = __webpack_public_path__ + "img/help-editboard.121c37ef.png";